import { NgModule } from '@angular/core'
import { SignupComponent } from './signup.component'
import { CommonModule } from '@angular/common'
import { FunnelSharedModule } from '../shared/funnel-shared.module'
import { LandingPageModule } from '../landing-page/landing-page.module'
import { BatmanDataService } from '../landing-page/batman-data.service'
import { SignupRoutingModule } from './signup-routing.module'

@NgModule({
  imports: [CommonModule, FunnelSharedModule, LandingPageModule, SignupRoutingModule],
  exports: [SignupComponent],
  declarations: [SignupComponent],
  providers: [BatmanDataService]
})
export class SignupModule {}
